import { render, staticRenderFns } from "./FormCouponReview.vue?vue&type=template&id=e18fed58&"
import script from "./FormCouponReview.vue?vue&type=script&lang=js&"
export * from "./FormCouponReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports